<template>
  <section class="share-video">
    <h1>{{ info.courseName || '精品课程' }}</h1>

    <div class="share-video-main">
      <img class="share-video-main-avatar" :src="info.avatar ? info.avatar : './.default/avatar.png'" alt="avatar" @click.prevent/>
      <img class="share-video-main-bg" src="../../assets/images/share_video_bg.png" alt="share" @click.prevent/>
      <hr/>

      <div class="share-video-main-stat">
        <dl class="share-video-main-stat-days">
          <dt>{{ info.daysPassed || 0 }}</dt>
          <dd>累计学习（天）</dd>
        </dl>
        <div class="share-video-main-stat-sep"/>
        <dl class="share-video-main-stat-minutes">
          <dt>{{ Math.round((info.learnSeconds || 0) / 60) }}</dt>
          <dd>累计时长（分钟）</dd>
        </dl>
      </div>

      <img class="share-video-main-title" src="../../assets/images/share_title.png" alt="today"/>

      <p class="share-video-main-content">
        {{ info.benefit || info.shareContent || '微课荣誉出品' }}
      </p>

      <img class="share-video-main-qrArea" v-if="!fromShare" src="../../assets/images/share_qr.png" alt="qr"/>
      <img class="share-video-main-qrArea" v-else src="../../assets/images/share_qr_invi.png" alt="qr"/>
      <img class="share-video-main-qrCode" :src="info.qrcode" alt="qrCode"/>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    fromShare:{
      type: Boolean,
    },
    info: {
      type: Object,
      default () {
        return {
          'avatar': './.default/avatar.png',
          'benefit': '微课荣誉出品',
          'chapterId': '',
          'chapterName': '',
          'courseId': '',
          'courseName': '微课程',
          'daysPassed': 0,
          'qrcode': './.default/qrcode.png',
          'shareContent': '与微课一起成长！',
          'shareImg': '',
          'teacher': {
            'image': './.default/avatar.png',
            'name': '老师'
          },
          'tryBvo': {
            'length': 124,
            'name': '测试音频',
            'video': 'http://boscdn.bpc.baidu.com/v1/developer/41e53261-cabc-46dc-84d6-3f1218ccb28d.mp3'
          }
        }
      }
    },

  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

.share-video {
  position: relative;
  height: 100%;
  width: 100%;

  h1 {
    width: rem(640);
    margin: rem(46) auto;
    color: #fff;
    font-size: rem(40);
    line-height: rem(50);
    text-shadow: 0 rem(5) rem(10) rgba(130, 27, 0, 0.3);
    text-align: center;
  }

  &-main {
    position: relative;
    height: rem(916);
    width: 100%;
    margin: 0 auto;

    &-bg {
      position: absolute;
      top: rem(15);
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 100%;
    }

    &-avatar {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 99;
      height: rem(100);
      width: rem(100);
      border-radius: 50%;
    }

    hr {
      position: absolute;
      top: rem(340);
      left: 0;
      right: 0;
      margin: 0 auto;
      width: rem(611);
      border: none;
      border-top: rem(3) dashed #c9c9c9;
    }

    &-stat {
      position: absolute;
      top: rem(164);
      left: 0;
      right: 0;
      margin: 0 auto;
      height: rem(94);
      width: rem(489);

      &-sep {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        margin: 0 auto;
        height: rem(84);
        width: 1px;
        background-color: #d8d8d8;
      }

      dl {
        height: 100%;
        width: rem(198);
        text-align: center;

        dt {
          color: #666;
          font-size: rem(50);
          margin-bottom: rem(20);
        }

        dd {
          color: #666;
          font-size: rem(24);
        }
      }

      &-days {
        float: left;
      }

      &-minutes {
        float: right;
      }
    }

    &-title {
      position: absolute;
      top: rem(404);
      left: 0;
      right: 0;
      margin: 0 auto;
      height: rem(31);
      width: rem(250);
    }

    &-content {
      position: absolute;
      top: rem(450);
      left: 0;
      right: 0;
      margin: 0 auto;
      width: rem(460);
      color: #666;
      font-size: rem(30);
      line-height: rem(52);
    }

    &-qrArea {
      position: absolute;
      bottom: rem(-5.7);
      left: 0;
      right: 0;
      margin: 0 auto;
      height: rem(190);
      width: rem(640);
    }

    &-qrCode {
      position: absolute;
      bottom: rem(19.3);
      left: rem(170);
      height: rem(140);
      width: rem(140);
    }
  }
}
</style>
